import { render, staticRenderFns } from "./refund-icon.vue?vue&type=template&id=ca3b801e&functional=true&"
import script from "./refund-icon.vue?vue&type=script&lang=js&"
export * from "./refund-icon.vue?vue&type=script&lang=js&"
import style0 from "./refund-icon.vue?vue&type=style&index=0&id=ca3b801e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports